<template>
  <div class="mx-6 my-6 relative">
    <div class="sm:flex sm:items-center">
      <div class="flex-auto flex items-center space-x-5">
        <div class="flex-shrink-0">
          <div class="relative bg-orange-600/70 rounded-xl p-1">
            <mdicon name="phone-message" size="62" class="text-orange-100" aria-hidden="true"></mdicon>
          </div>
        </div>
        <div class="">
          <h1 class="text-2xl font-bold text-gray-900">Phone Numbers</h1>
          <p class="text-sm font-medium text-gray-500">Manage phone numbers in your account</p>
        </div>
      </div>

      <div class="flex items-center mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
        <!--<button
          v-if="showDelete"
          type="button"
          class="mr-2 flex items-center gap-x-1 rounded-md bg-red-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
          @click="onDeleteUsers"
        >
          <mdicon name="minus-circle-outline" class="h-6 w-6" aria-hidden="true"></mdicon>
          Delete
        </button>-->
      </div>
    </div>

    <div class="mt-8">
      <DataTable :value="allNumbers" paginator :rows="25" :rowsPerPageOptions="[25, 50, 100]" removableSort tableStyle="min-width: 50rem" class="" rowHover>
        <!--<Column selectionMode="multiple" headerStyle="width: 2rem"></Column>-->
        <Column field="id" header="Number" sortable>
          <template #body="slotProps">
            <div class="flex items-center">
              <mdicon name="phone-message" size="24" class="mr-1 text-slate-300" aria-hidden="true"></mdicon>
              <div class="font-semibold cursor-pointer hover:underline" @click="onEditNumber(slotProps.data)">{{ slotProps.data.id }}</div>
            </div>
          </template>
        </Column>
        <Column field="voiceBotId" header="Voice Bot" sortable>
          <template #body="slotProps">
            <router-link v-if="slotProps.data?.voiceBotId && slotProps.data.voiceBotId.length > 0" :to="{ path: `/bots/editor/${slotProps.data.voiceBotId}` }" _target="blank">
              <div class="flex items-center">
                <div class="cursor-pointer hover:underline">{{ getBotName(slotProps.data?.voiceBotId) }}</div>
                <mdicon name="open-in-new" size="18" class="ml-1 text-slate-300"></mdicon>
              </div>
            </router-link>
          </template>
        </Column>
        <!--
        <Column field="smsBotId" header="SMS Bot" sortable>
          <template #body="slotProps">
            <router-link v-if="slotProps.data?.smsBotId && slotProps.data.smsBotId.length > 0" :to="{ path: `/bots/editor/${slotProps.data.smsBotId}` }">
              <div class="flex items-center">
                <div class="cursor-pointer hover:underline">{{ getBotName(slotProps.data?.smsBotId) }}</div>
                <mdicon name="open-in-new" size="18" class="ml-1 text-slate-300"></mdicon>
              </div>
            </router-link>
          </template>
        </Column>
        -->
        <Column field="handoffNumber" header="Handoff Number" sortable />
        <Column field="updated" header="Last Updated" sortable>
          <template #body="slotProps"> {{ slotProps.data?.updated ? dayjs(slotProps.data.updated).format('MM/DD/YYYY') : '' }} </template>
        </Column>
        <Column field="updatedBy" header="Updated By" sortable> </Column>
        <!--
        <Column style="width: 1%">
          <template #body="slotProps">
            <Button type="button" size="small" icon="pi pi-ellipsis-v" rounded severity="secondary" @click="(event) => toggleNumberMenu(event, slotProps?.data)" />
          </template>
        </Column>
        -->
      </DataTable>
    </div>
    <SettingsDialogEditPhoneNumber ref="dialogEditPhoneNumber" @save="onSaveNumber"></SettingsDialogEditPhoneNumber>
  </div>
</template>

<script setup>
  import { useAuthStore } from '@/store/AuthStore';
  import { useSettingsStore } from '@/store/SettingsStore';
  import { useBotsStore } from '@/store/BotsStore';
  import { useCollection } from 'vuefire';
  import { ref, computed } from 'vue';
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import SettingsDialogEditPhoneNumber from '@/components/Settings/dialogs/SettingsDialogEditPhoneNumber.vue';
  import { fbDb } from '@/firebaseApp';
  import { collection } from 'firebase/firestore';
  import dayjs from 'dayjs';

  const authStore = useAuthStore();
  const settingsStore = useSettingsStore();
  const botsStore = useBotsStore();

  const dialogEditPhoneNumber = ref(null);

  const numbersCollection = useCollection(collection(fbDb, `tenants/${authStore.tenantId}/phoneNumbers`));

  const allNumbers = computed(() => {
    return numbersCollection.value.map((x) => {
      return { ...x, id: x.id };
    });
  });

  const editNumberOpen = ref(false);
  const numberToEdit = ref(null);

  async function onEditNumber(number) {
    console.log(`onEditNumber:`, number);
    dialogEditPhoneNumber.value.start(number);
  }

  async function onSaveNumber(updatedNumber) {
    await settingsStore.updatePhoneNumber(updatedNumber);
  }

  function toggleNumberMenu(number) {
    console.log(`toggleNumberMenu:`, number);
  }

  function getBotName(botId) {
    if (!botId) {
      return '-';
    }
    const bot = botsStore.getBot(botId);
    if (!bot) {
      return '-';
    }
    return bot?.name || '-';
  }
</script>
